const PeruSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112147)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M40.0001 20.0011C40.0001 11.4018 34.5726 4.0709 26.9565 1.24512V38.7572C34.5726 35.9312 40.0001 28.6004 40.0001 20.0011Z"
        fill="#D80027"
      />
      <path
        d="M0 20.0011C0 28.6004 5.4275 35.9312 13.0435 38.7571V1.24512C5.4275 4.0709 0 11.4018 0 20.0011Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112147">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PeruSvg;
